import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import React from 'react';
import { PageContainer } from '../../components/container/PageContainer';
import { GuardedAdminPage } from '../guard-pages/GuardedAdminPage';
import { AdminCoursesTab } from './AdminCoursesTab';
import { AdminRegistrationsTab } from './AdminRegistrationsTab';
import { AdminConfigTab } from './AdminSettingsTab';
import { AdminUsersTab } from './AdminUsersTab';

const MotionBox = motion(Box);

interface AdminPageProps {}

export const AdminPage: React.FC<AdminPageProps> = () => (
  <GuardedAdminPage>
    <PageContainer isHeader>
      <MotionBox
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0, transition: { ease: 'easeOut' } }}
        exit={{ opacity: 0, y: 10, transition: { ease: 'easeOut' } }}
      >
        <Tabs w="full" colorScheme="brand" isLazy={true}>
          <TabList
            mb={6}
            flexDirection={['column', 'column', 'row']}
            borderBottomColor={['transparent', 'transparent', 'gray.200']}
          >
            <Tab borderTopRadius="xl" whiteSpace="nowrap">
              Kurse
            </Tab>
            <Tab borderTopRadius="xl" whiteSpace="nowrap">
              Kurs-Registrierungen
            </Tab>
            <Tab borderTopRadius="xl" whiteSpace="nowrap">
              Mitglieder & Leads
            </Tab>
            <Tab borderTopRadius="xl" whiteSpace="nowrap">
              Einstellungen
            </Tab>
            {/* <Tab>Empfehlungs-Algoithmus</Tab> */}
            {/* <Tab>Trainer/in</Tab> */}
          </TabList>
          <TabPanels>
            <TabPanel p={0}>
              <AdminCoursesTab />
            </TabPanel>
            <TabPanel p={0}>
              <AdminRegistrationsTab />
            </TabPanel>
            <TabPanel p={0}>
              <AdminUsersTab />
            </TabPanel>
            <TabPanel p={0}>
              <AdminConfigTab />
            </TabPanel>
            <TabPanel p={0}>
              <Text>coming soon</Text>
              {/* <AdminDecisionTreeTab /> */}
            </TabPanel>
            <TabPanel p={0}>
              <Text>coming soon</Text>
              {/* <AdminDecisionTreeTab /> */}
            </TabPanel>
            {/* <TabPanel p={0}>
            <AdminTrainerTab />
          </TabPanel> */}
          </TabPanels>
        </Tabs>
      </MotionBox>
    </PageContainer>
  </GuardedAdminPage>
);
